import { Line } from 'react-chartjs-2'
import { Grid } from '@material-ui/core'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'
import { useStyles } from '../styles'

const TotalEasyToResumGraphsCard = props => {
  const { arrayGB, arrayGA, titleCard } = props
  const classes = useStyles()
  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>{titleCard}</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación de mercado en unidades – año</h3>
            <br />
            {Array.isArray(arrayGA[1]) &&
              arrayGA[0]?.map((graphA, index) => (
                  <>
                    <div className={classes.center}>
                      {Array.isArray(arrayGA[1]) && (
                        <div>
                          {' '}
                          <h3> {arrayGA[1][index].subsegmento}</h3>{' '}
                        </div>
                      )}
                      {`  `}
                    </div>
                    <Line
                      data={Utils.customBarLineDataGroup(graphA, 'EMPRESA', 'PORCENTAJE', 'y', '100')}
                      options={Utils.optionsLine}
                    />
                    <br />
                  </>
                ))}
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación de mercado en unidades – mes</h3>
            <br />
            <br />
            {Array.isArray(arrayGB[1]) &&
              arrayGB[0]?.map((graphA, index) => (
                  <>
                    <div className={classes.center}>
                      {Array.isArray(arrayGB[1]) && (
                        <div>
                          {' '}
                          <h3> {arrayGB[1][index].subsegmento}</h3>{' '}
                        </div>
                      )}
                      {`  `}
                    </div>
                    <Line
                      data={Utils.customBarLineDataGroup(graphA, 'EMPRESA', 'PORC', 'MES', '100')}
                      options={Utils.optionsLine}
                    />
                    <br />
                  </>
                ))}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default TotalEasyToResumGraphsCard
